import { useNavbarState } from './NavbarProvider';

const useNavbarHeight = () => {
  const { navbarHeight, setNavbarHeight } = useNavbarState();

  return { navbarHeight, setNavbarHeight };
};

export default useNavbarHeight;
